module.exports = __webpack_public_path__ + "assets/images/01_decd16756a95c22414f7116bab411366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/01.png
// module id = 178
// module chunks = 0